export default "__VITE_PUBLIC_ASSET__0c0ae2dd__"